import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastr: ToastrService) { }

  showMessages(
    type: 'success' | 'error' | 'warning' | 'info',
    messages: string[] = [],
    extraMessage?: string
  ) {
    const msgs = [...messages];
    if (extraMessage) {
      msgs.unshift(extraMessage);
    }
    if (msgs.length === 0) return;

    msgs.forEach(msg => {
      switch (type) {
        case 'success': this.toastr.success(msg); break;
        case 'error': this.toastr.error(msg); break;
        case 'warning': this.toastr.warning(msg); break;
        case 'info': this.toastr.info(msg); break;
        default: this.toastr.show(msg); break;
      }
    });
  }
}
